import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Template from "@/services/template/template";
import type { EditTemplate } from "@/dtos/Template.dto";

export function useCopyTemplate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const response = await Template.copyTemplate({
        id,
        name: "",
        subject: "",
        content: "",
        lastUsedAt: new Date(),
        templateFolderId: "",
        organizationId: "",
      } as EditTemplate);
      if (!response.data.status) {
        throw new Error(response.data.msg || "Failed to copy template");
      }
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["templates"] });
    },
  });
}
